import {
    FETCH_THOT_AUTOCLAVESMONITOR,
    FETCH_THOT_I4MONITOR, RECEIVE_THOT_AUTOCLAVESMONITOR, RECEIVE_THOT_I4MONITOR

} from "../actions/actionTypes";
import autoclave from "../pages/Producao/PainelTVAutoclave/Autoclave";

const initalState = {
    isFetchingi4Monitor: false,
    i4Monitor: [],
    isFetchingAutoclavesMonitor: false,
    autoclavesMonitor: [],
    lastAutoclaveTntIx: -1

}



export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_THOT_I4MONITOR:
            return {
                ...state,
                isFetchingi4Monitor: true
           //     estacoesTrabalho: []
            }
        case RECEIVE_THOT_I4MONITOR:
            return {
                ...state,
                isFetchingi4Monitor: false,
                i4Monitor: action.payload
            }

        case FETCH_THOT_AUTOCLAVESMONITOR:
            return {
                ...state,
                isFetchingAutoclavesMonitor: true
                //     estacoesTrabalho: []
            }

        case RECEIVE_THOT_AUTOCLAVESMONITOR:

            if (action.payload.error) {
                return {
                    ...state,
                    isFetchingAutoclavesMonitor: false,
                    lastAutoclaveTntIx: action.payload.ix
                }
            }

            if (action.payload.data && action.payload.data.length === 0) {
                return {
                    ...state,
                    isFetchingAutoclavesMonitor: false,
                    tntId: action.payload.tntId,
                    lastAutoclaveTntIx: action.payload.ix
                }
            }

            let newData = state.autoclavesMonitor;

                const ix = state.autoclavesMonitor.findIndex( (pa) => pa.tntId === action.payload.tntId)
                if (ix >=0) {
                    newData[ix] = action.payload;
                } else {
                    newData.unshift(action.payload)
                }




            return {
                ...state,
                isFetchingAutoclavesMonitor: false,
                lastAutoclaveTntIx: action.payload.ix,
                autoclavesMonitor: newData
            }


        default:
            return state;
    }
}
